import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {Button, Card, CardBody, CardHeader, Container, Form,} from "reactstrap";
import ChangePasswordForm from "./ChangePasswordForm";
import AuthService from "../../../services/authService";
import ReactBSAlert from "react-bootstrap-sweetalert";
import ChangeSurveyTypeForm from "./ChangeSurveyTypeForm";
import _ from "lodash";
import UtilService from "../../../services/utilService";
import ReviewQuestionService from "../../../services/reviewQuestionService";
import ReviewService from "../../../services/reviewService";
import {reviewType} from "../../../util/reviewType";
import NotificationAlert from "react-notification-alert";
import TinyMceEditor from "../../../components/editor/TinyMceEditor";
import Brand from "./user/Brand";

class UserSettings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorData: {},
            alert: null,
            selectedReviewType: {},
            reviewType: "",
            selectReviewTypeKey: UtilService.uuidv4(),
            questionsList: [],
            updateSurveyTypeEnabled: true,
            reviewsSearchEnabled: false,
            selectReviewsSearchEnabledKey: UtilService.uuidv4(),
            selectedReviewsSearchEnabled: {},
            isDisabled: false,
            htmlContent:"",
            userId:""

        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        this.setState({[event.target.name]: event.target.value});
    }

    handleSubmit(event) {
        event.preventDefault();
        AuthService.changePassword(this.state).then((response) => {
            console.log(response.data);
            if (response.responseStatus === "SUCCESS") {
                this.logoutTimeAlert();
            } else {
                this.setState({errorData: response.data});
                console.error("Error    ==>     " + response.message);
            }
        });
    }

    componentDidMount() {
        ReviewQuestionService.listByTenant().then(response => {
            this.setState({questionsList: response}, () => {
                console.log(this.state);
            })
        })

        ReviewService.companyDescription(localStorage.getItem("userId")).then(response => {
            console.log(response)
            this.setState({htmlContent:response.companyDescriptionMarkup, userId: response?.uniqueId})
        })

        ReviewService.fetchSettingForUser().then(response => {
            if (response.reviewType) {
                const reviewTypeSaved = reviewType.find(value => value.key === response.reviewType)
                console.log(reviewTypeSaved)
                this.setState({reviewType: response.reviewType, selectedReviewType: reviewTypeSaved, selectReviewTypeKey: UtilService.uuidv4(), isDisabled: true});
                let selectedReviewSearchEnabled = _.find([{key:true,value:"YES"},{key:false, value:"NO"}], val=> val.key === response.reviewsSearchEnabled)
                this.setState({selectedReviewsSearchEnabled: selectedReviewSearchEnabled, reviewsSearchEnabled: response.reviewsSearchEnabled ? true : false, selectReviewsSearchEnabledKey: UtilService.uuidv4()});
            } else {
                console.log(response);
            }
        })
    }

    notify = (type, title, message) => {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
                    <span data-notify="message">{message}</span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 5,
        };
        this.refs.notificationAlert.notificationAlert(options);
    };

    handleCompanyDescriptionSubmit = () => {
        const data = {
            companyDescriptionMarkup : this.state.htmlContent
        }
        ReviewService.updateCompanyDescription(data).then(response =>{
            console.log(response)
            this.notify(
                "success",
                "Success",
                "Description Updated Successfully!"
            );
        })
    }


    handleReviewTypeSubmit = (event) => {
        event.preventDefault();
        console.log(this.state)
        const data = {
            reviewType: this.state.reviewType,
            reviewsSearchEnabled: this.state.reviewsSearchEnabled,
        }
        console.log(data)
        ReviewService.createSetting(data).then((response) => {
            console.log(response);
            this.notify(
                "success",
                "Success",
                "Setting Updated Successfully!"
            );
        })
        /*
                XgReviewService.changeReviewType(this.state).then((response) => {
                    console.log(response.data);
                    if (response.responseStatus === "SUCCESS") {

                    } else {
                        this.setState({errorData: response.data});
                        console.error("Error    ==>     " + response.message);
                    }
                });
        */
    }

    logoutTimeAlert = () => {
        this.setState({
            alert: (
                <ReactBSAlert
                    style={{display: "block", marginTop: "0px"}}
                    title="Password Changed!"
                    onConfirm={() => this.hideAlert()}
                    showConfirm={true}
                >
                    Password successfully Changed. You will be redirected to login Screen! Please login again.
                </ReactBSAlert>
            )
        });
        setTimeout(this.hideAlert, 5000);
    };

    hideAlert = () => {
        this.setState({
            alert: null
        });
        localStorage.clear();
        this.props.history.push("/")
    };

    handleReviewTypeChange = (valueObj, event) => {
        if (_.isNull(valueObj)) {
            this.setState({reviewType: ""});
        } else {
            this.setState({selectedReviewType: valueObj});
            // const keys = _.map(valueObj, "key")
            this.setState({reviewType: valueObj.key});
        }
    };
    handleReviewSearchEnabledChange = (valueObj, event) => {
        if (_.isNull(valueObj)) {
            this.setState({reviewsSearchEnabled: ""});
        } else {
            this.setState({selectedReviewsSearchEnabled: valueObj});
            // const keys = _.map(valueObj, "key")
            this.setState({reviewsSearchEnabled: valueObj.key});
        }
    };

    render() {
        return (
            <>
                <div className="rna-wrapper">
                    <NotificationAlert ref="notificationAlert"/>
                </div>
                <SimpleHeader
                    name="Settings"
                    parentName="Settings"
                    heading="XareGrowth"
                    /*newBtnUrl="/admin/student/create"
                    newBtnText="Create Student"*/
                />
                <Container className="mt--6" fluid>
                    <Card className="mb-4">
                        <CardHeader>
                            <h3 className="mb-0">Change Password</h3>
                        </CardHeader>
                        {this.state.alert}
                        <CardBody>
                            <Form role="form" onSubmit={this.handleSubmit}>
                                <ChangePasswordForm
                                    onChange={this.handleChange}
                                    valueObj={this.state}
                                    errorObj={this.state.errorData}
                                    isEdit={false}
                                />
                                <div className="text-center">
                                    <Button outline className="my-4" color="default" type="submit">
                                        Change Password
                                    </Button>
                                </div>
                            </Form>
                        </CardBody>
                    </Card>
                </Container>
                <br/>
                <br/>
                <br/>
                <Brand/>
                <br/>
                <br/>
                <br/>
                <Container className="mt--6" fluid>
                    <Card className="mb-4">
                        <CardHeader>
                            <h3 className="mb-0">Review Settings</h3>
                        </CardHeader>
                        {this.state.alert}
                        <CardBody>
                            <Form role="form" onSubmit={this.handleReviewTypeSubmit}>
                                <ChangeSurveyTypeForm
                                    onChange={this.handleChange}
                                    valueObj={this.state}
                                    errorObj={this.state.errorData}
                                    isEdit={false}
                                    isDisabled={this.state.isDisabled}
                                    selectReviewTypeKey={this.state.selectReviewTypeKey}
                                    onReviewTypeChange={this.handleReviewTypeChange}
                                    selectedReviewType={this.state.selectedReviewType}
                                    selectReviewsSearchEnabledKey={this.state.selectReviewsSearchEnabledKey}
                                    selectedReviewsSearchEnabled={this.state.selectedReviewsSearchEnabled}
                                    onReviewSearchEnabledChange={this.handleReviewSearchEnabledChange}
                                />
                                <div className="text-center">
                                    <Button outline className="my-4" color="default" type="submit">
                                        Save Settings
                                    </Button>
                                </div>
                            </Form>
                        </CardBody>
                    </Card>
                </Container>
                <br/>
                <br/>
                <br/>
                <Container className="mt--6" fluid>
                    <Card className="mb-4">
                        <CardHeader>
                            <div className="d-flex justify-content-between align-items-center mb-0">
                                <h3 className="mb-0">Company Description</h3>
                                <Button
                                    outline
                                    className="my-4"
                                    color="default"
                                    type="button"
                                    onClick={() => {
                                        this.props.history.push(`/company/${this.state.userId}`);
                                    }}
                                >
                                    View Company
                                </Button>
                            </div>

                        </CardHeader>
                        {this.state.alert}
                        <CardBody>
                            <TinyMceEditor
                                value={this.state.htmlContent}
                                onEditorChange={(html) => this.setState({htmlContent: html})}
                                toolbar="undo redo | bold italic underline | alignleft aligncenter alignright"
                                height={400}
                            />
                            <div className="text-center">
                                <Button outline className="my-4" color="default" type="button"
                                        onClick={() => {
                                            this.handleCompanyDescriptionSubmit();
                                        }}
                                >
                                    Save Description
                                </Button>
                            </div>
                        </CardBody>
                    </Card>
                </Container>
            </>
        );
    }
}

export default UserSettings;
